import React from "react";
import { HStack, Button } from "@chakra-ui/react";

const WINDOWS = [
  { value: "24h", label: "24h" },
  { value: "7d", label: "7d" },
  { value: "30d", label: "30d" },
  { value: "90d", label: "90d" },
  { value: "all", label: "All" },
];

export default function AnalyticsTimeWindow({ value, onChange }) {
  return (
    <HStack spacing={2}>
      {WINDOWS.map((w) => (
        <Button
          key={w.value}
          size="sm"
          variant={value === w.value ? "solid" : "outline"}
          colorScheme={value === w.value ? "blue" : "gray"}
          onClick={() => onChange(w.value)}
        >
          {w.label}
        </Button>
      ))}
    </HStack>
  );
}
